import { APIService } from '@services/api/common-services';
import { useMutation, UseMutateFunction } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { UploadMeetingImagePayload } from '.';

interface IUploadMeetingImages {
	mutate: UseMutateFunction<UploadMeetingImagePayload, Error, UploadMeetingImagePayload, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useUploadMeetingImagesMutation = (): IUploadMeetingImages => {
	const uploadMeetingImages = async (payload: UploadMeetingImagePayload): Promise<UploadMeetingImagePayload> => {
		return await APIService.postData<UploadMeetingImagePayload>(APICONFIG.MEETING_MEDIA_URL, payload);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: uploadMeetingImages,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
